module.exports = __webpack_public_path__ + "static/media/openbrixlogo.15c99ce8.png";